// playground will init the global tailwind object
import './playground.js';
// needed for purging
import { createTailwindcss } from './module.esm.js';

console.log('playground', tailwind);

if (window.self === window.top) {
  blockbite.createTailwindcss = createTailwindcss;
}
